<template>
  <div>
    <v-row v-if="title" class="my-0" no-gutters>
      <span :class="{'_subtitleFormFont': !smallFont, '_subtitleFormFont _subtitleFormFontSmall': smallFont}">{{ title }}:</span>
    </v-row>
    <div :class="['cardColor', {'disabled': disabled}]">
      <v-row no-gutters style="height: 100%; align-items: center; flex-wrap: nowrap">
        <v-menu v-model="menu" offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-flex align-center ellipsis">
              <v-card
                elevation="0"
                :class="['color', {'compact-style': compact}]"
                :color="getColor"
              ></v-card>
              <span v-if="getColor && !compact" class="mt-0 ml-3">{{ getColor }}</span>
              <span v-else-if="!getColor && !compact" class="noValue mt-0 ml-3">Selecione uma cor</span>
            </div>
          </template>
          <v-color-picker
            :mode="mode"
            hide-mode-switch
            swatches-max-height="173"
            v-model="color"
            @input="changeColor($event)"
          ></v-color-picker>
        </v-menu>

        <div v-if="getColor" class="d-flex flex justify-end">
          <v-btn x-small fab elevation="0" color="transparent" @click="changeColor(defaultColor)">
            <v-icon size="13" color="#24252D">fa-solid fa-xmark</v-icon>
          </v-btn>
        </div>
        
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    colorSelected: { type: Object },
    model: { type: String, default: "" },
    type: { type: String },
    title: { type: String, default: "Cor" },
    compact: {type: Boolean},
    disabled: {type: Boolean},
    defaultColor: {type: String, default: ''},
    smallFont: {type: Boolean, default: false},
    mode: {type: String, default: 'hexa'} //hexa, rgba
  },

  data() {
    return {
      hex: "#ffffff",
      menu: false,
    };
  },

  computed: {
    ...mapGetters(["saveConfig"]),

    color: {
      get() {
        return this["hex"];
      },
      set(v) {
        this["hex"] = v;
      },
    },

    showColor() {
      if (typeof this.color === "string") return this.color;

      return JSON.stringify(
        Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2));
          return color;
        }, {}),
        null,
        2
      );
    },

    getColor() {
      return this.type !== "model" ? this.colorSelected[this.type] : this.model;
    }
  },

  watch: {
    menu() {
      if (this.menu && this.colorSelected[this.type]) {
        this.color = this.colorSelected[this.type];
      }

      if (!this.menu) this.save();
    },
  },

  mounted() {
    this.colorSelected[this.type] = this.colorSelected[this.type]
      ? JSON.parse(JSON.stringify(this.colorSelected[this.type]))
      : this.defaultColor
  },

  methods: {
    changeColor(event) {
      if (this.type !== "model") this.colorSelected[this.type] = event;
      else this.$emit("changeColor", event);
    },

    save() {
      // this.saveConfig();
    },
  },
};
</script>

<style scoped>
.cardColor {
  height: 40px;
  /* width: 130px; */
  border-radius: 8px;
  background-color: #F6F7F7;
  border: 1px solid #EDEDF1;
  box-sizing: border-box;
  font-size: 0.9rem !important;
  font-weight: 400 !important;
}

.cardColor span {
  color: #24252D !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cardColor span.noValue {
  color: #9E9E9E !important;
}

.disabled {
  pointer-events: none;
  opacity: 0.7;
}

.color {
  min-width: 24px;
  min-height: 24px;
  margin-left: 6px;
  background: #ffffff;
  border: 1px solid #c8ccd3;
  box-sizing: border-box;
  border-radius: 4px;
  color: #24252D !important;
}

.compact-style {
  width: 54px;
}

.ellipsis {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
